<template>
  <div>
    <div class="block">
    <el-carousel trigger="click" height="450px">
      <el-carousel-item v-for="(item,idx) in mainpic" :key="item" >
        <div class="carbg">
          <div v-if="idx===0">
          <h2>中国国旅（宁波）国际旅行社有限公司</h2>
          <h3>中国国旅，品质之旅</h3>
          </div>
          <div v-if="idx===1">
          <h2>山高人为峰</h2>
          <h3>中国国旅，带您体验非凡的行程</h3>
          </div>
          <div v-if="idx===2">
          <h2>国旅一家人</h2>
          <h3>为你，为我，为大家</h3>
          </div>
        </div>
        <img :src="item"/>
      </el-carousel-item>
    </el-carousel>
  </div>
  </div>
</template>

<script>


import pic1 from "@/assets/images/bg/1.jpg"
import pic2 from "@/assets/images/bg/2.jpg"
import pic3 from "@/assets/images/bg/3.jpg"
export default {
  name: "index",
  components: {

  },
  data() {
    return {
      mainpic: [
        pic1, pic2, pic3
      ]
    }
  }
};
</script>
<style lang="less">
.el-carousel__item {
  .carbg {
    position: absolute;
    width: 100%;
    height: 450px;
    background-color: rgba(0, 0, 0, 0.3);
  }
  h2 {
    width: 100%;
    position: absolute;
    color: #fff;
    font-size: 30px;
    text-align: center;
    opacity: 0.75;
    top: 150px;
    margin: 0;
  }
  h3 {
    width: 100%;
    position: absolute;
    color: #fff;
    font-size: 20px;
    text-align: center;
    opacity: 0.75;
    top: 200px;
    margin: 0;
  }
}
</style>

